let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("83hRt")).then(() => parcelRequire('kSbNs'));